const contactUsLinkClick = (contactType) => {
  window.dataLayer.push({event: 'contact_us', contact_type: contactType});
};

export default contactUsLinkClick;
